var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-progress-bar",style:({
  width: _vm.percent + '%',
  backgroundColor: _vm.isSuccess ? _vm.successColor : _vm.failedColor,
  opacity: _vm.show ? 1 : 0,
})})
}
var staticRenderFns = []

export { render, staticRenderFns }